import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconInformationOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0c6.628 0 12 5.373 12 12s-5.372 12-12 12m0-22.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5M11.25 18v-7.5h1.5V18zM12 7.5A.75.75 0 1 1 12 6a.75.75 0 0 1 0 1.5" /></svg>
);
